import { isValid } from 'date-fns';
import { validateArguments } from '../../SignatureValidation';
import { Parser, Types } from '../../Switch';
import { ExprError } from '../ExprError';
export var DateTimeFn;
(function (DateTimeFn) {
    DateTimeFn.Name = `DATETIME`;
    DateTimeFn.Stage = "SCALAR";
    DateTimeFn.Signature = `DATETIME(<expression>)`;
    function make(callName, args, type, role) {
        return {
            name: DateTimeFn.Name,
            stage: DateTimeFn.Stage,
            data: { type, role },
            value: (...argVals) => {
                if (argVals.length !== 1) {
                    throw new Error(`DATETIME function needs 1 argument but received ${argVals.length}`);
                }
                const [value] = argVals;
                if (value == null) {
                    return null;
                }
                const parseDate = Parser.Parsers.date;
                if (typeof value === 'string') {
                    const trimmedValue = value.trim();
                    if (trimmedValue === '') {
                        return null;
                    }
                    const date = new Date(trimmedValue);
                    if (!isValid(date)) {
                        return null;
                    }
                    const ISODate = date.toISOString();
                    const parsedResult = parseDate(ISODate);
                    if (parsedResult instanceof Error) {
                        return null;
                    }
                    return parsedResult * 1000;
                }
                if (typeof value === 'number') {
                    if (Types.nodeResolvesToDateLikeType(args[0])) {
                        return value;
                    }
                    const date = new Date(value);
                    if (!isValid(date)) {
                        return null;
                    }
                    const ISODate = date.toISOString();
                    let parsedResult = parseDate(ISODate);
                    if (parsedResult instanceof Error) {
                        return null;
                    }
                    parsedResult = parsedResult * 1000;
                    return parsedResult;
                }
                throw new Error(`DATETIME function expects number, string or date input`);
            },
        };
    }
    DateTimeFn.make = make;
    function validate(callNode, callName, args) {
        return validateArguments({
            meta: { name: DateTimeFn.Name, signature: DateTimeFn.Signature, location: callNode.location },
            arguments: [
                {
                    customValidation: (node) => {
                        const type = Types.getResolvedType(node);
                        switch (Types.getResolvedType(node)) {
                            case "INTEGER":
                            case "FLOAT":
                            case "STRING":
                            case "TIMESTAMP":
                            case "DATE_TIME":
                                return [];
                        }
                        return [
                            new ExprError.InvalidArgument(DateTimeFn.Name, null, `expected NUMERIC or STRING input but saw ${type}`, callNode.location),
                        ];
                    },
                },
            ],
        }, args);
    }
    DateTimeFn.validate = validate;
})(DateTimeFn || (DateTimeFn = {}));
